<template>
  <v-dialog
    v-model="isOpen"
    persistent
    :max-width="attrs['max-width'] ?? 600"
    v-bind="attrs"
    transition="dialog-transition"
    @keydown.esc="emit('on-close')"
  >
    <!-- Encaminha o slot activator para o v-dialog -->
    <template #activator="{ props }">
      <slot name="activator" v-bind="props" />
    </template>

    <v-card class="premium-dialog">
      <v-card-title class="premium-dialog__title">
        <h2 class="title">{{ title }}</h2>
      </v-card-title>

      <v-card-text class="premium-dialog__content overflow-auto">
        <slot name="content" />
      </v-card-text>

      <v-divider v-if="hasFooter" class="premium-dialog__divider" />

      <v-card-actions class="premium-dialog__actions">
        <v-spacer />
        <slot name="footer" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch, useAttrs, useSlots } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  title: { type: String, default: '' },
  opened: { type: Boolean, default: false },
})
const emit = defineEmits(['update:opened', 'on-close'])

const attrs = useAttrs()
const slots = useSlots()
const hasFooter = !!slots.footer

const isOpen = ref(props.opened)
watch(() => props.opened, v => { isOpen.value = v })
watch(isOpen, v => emit('update:opened', v))
</script>

<style scoped>
/* Transição premium */
.dialog-transition-enter-active,
.dialog-transition-leave-active {
  transition: all 0.3s ease;
}
.dialog-transition-enter-from,
.dialog-transition-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

/* Card principal */
.premium-dialog {
  border-radius: 18px;
  overflow: hidden;
  box-shadow:
    0 10px 28px rgba(0, 0, 0, 0.12),
    0 4px 12px rgba(0, 0, 0, 0.08);
  background: #fff;
}

/* Header */
.premium-dialog__title {
  background: linear-gradient(
    135deg,
    rgb(var(--v-theme-primary)) 0%,
    color-mix(in oklab, rgb(var(--v-theme-primary)) 65%, white) 100%
  );
  color: #fff;
  padding: 16px 20px;
}
.title {
  font-weight: 700;
  font-size: 1.1rem;
  margin: 0;
}

/* Content */
.premium-dialog__content {
  padding: 24px;
  min-height: 10.5vh;
  max-height: 68vh;
  font-size: 0.95rem;
  color: #1f2937;
}

/* Divider */
.premium-dialog__divider {
  opacity: 0.15;
}

/* Footer */
.premium-dialog__actions {
  padding: 16px 20px;
}
</style>
